<template>
  <div class="privacy-page">
    <div class="container">
      <h1 class="title">隐私政策</h1>

      <div class="content">
        <p>
          欢迎使用企与星河！
          陕西点三信息技术有限公司提供的企与星河APP（“我们”或“服务”）
          非常重视您的隐私安全，并充分尊重您的隐私，感谢您对我们的信任。
        </p>

        <p>
          本声明适用于包含或援引本声明的所有企与星河相关产品和服务，
          包括但不限于网页、应用软件等。
        </p>

        <p>
          在使用本APP之前，请认真阅读本声明。
        </p>

        <section>
          <h2>重要提示</h2>

          <ul>
            <li>
              服务对象：本服务主要面向企业或组织客户，
              为企业或组织的员工提供协同办公服务。
            </li>

            <li>
              本声明仅适用于我们作为数据控制者情形下的个人数据。
            </li>
          </ul>
        </section>

        <section>
          <h2>1. 我们收集和使用哪些信息</h2>

          <h3>1.1 个人数据</h3>

          <p>
            个人数据是指单独使用或结合其他信息使用时能够识别
            或可能识别到个人身份的信息。
          </p>

          <p>
            我们会在您使用服务时收集您的个人数据，
            包括您提供的个人数据、系统收集的个人数据
            和从第三方获取的个人数据。
          </p>

          <h3>1.1.1 您提供的个人数据</h3>

          <ul>
            <li>姓名、手机号、邮箱、头像等注册信息</li>
            <li>实名认证信息（身份证、护照等）</li>
            <li>登录鉴权信息</li>
            <li>客服反馈及活动提交信息</li>
          </ul>

          <h3>1.1.2 系统收集的信息</h3>

          <ul>
            <li>设备型号、系统版本、Android ID 等设备信息</li>
            <li>IP地址、日志信息、网络状态</li>
            <li>应用崩溃日志与性能数据</li>
          </ul>

          <h3>1.2 客户及最终用户数据</h3>

          <p>
            在企业协同办公场景下，
            我们可能处理企业或组织授权的数据。
          </p>
        </section>

        <section>
          <h2>2. 我们如何使用您的个人信息</h2>

          <ul>
            <li>创建账户与身份验证</li>
            <li>企业通讯录与协同办公</li>
            <li>产品优化与数据分析</li>
            <li>系统安全与反欺诈</li>
            <li>法律法规要求的场景</li>
          </ul>
        </section>

        <section>
          <h2>3. Cookies 的使用</h2>

          <p>
            为确保服务正常运转，
            我们可能会在设备中存储 Cookie 信息，
            用于身份识别、用户偏好与安全控制。
          </p>
        </section>

        <section>
          <h2>4. 我们如何保护您的个人信息</h2>

          <ul>
            <li>采用加密技术保护数据安全</li>
            <li>建立访问权限控制机制</li>
            <li>定期开展安全审计与培训</li>
            <li>发生安全事件时依法通知用户</li>
          </ul>

          <p>
            根据《中华人民共和国网络安全法》，
            网络日志留存不少于六个月。
          </p>
        </section>

        <section>
          <h2>5. 您如何访问或控制您的个人数据</h2>

          <ul>
            <li>访问、更正、更新个人信息</li>
            <li>删除部分或全部个人数据</li>
            <li>撤销授权与权限</li>
            <li>注销账户</li>
          </ul>
        </section>

        <section>
          <h2>6. 儿童个人信息保护</h2>

          <p>
            如您属于未成年人，
            应在监护人同意和指导下使用本服务。
          </p>
        </section>

        <section>
          <h2>7. 第三方服务</h2>

          <p>
            本服务中可能包含第三方提供的链接、
            SDK 或其他服务内容。
            第三方的数据处理行为不受本声明约束。
          </p>
        </section>

        <section>
          <h2>8. 第三方 SDK</h2>

          <p>
            为实现消息推送、社交分享等功能，
            我们可能接入第三方 SDK。
          </p>
        </section>

        <section>
          <h2>9. 数据跨境传输</h2>

          <p>
            您的个人数据存储于中国大陆境内，
            不存在跨境传输情况。
          </p>
        </section>

        <section>
          <h2>10. 声明更新</h2>

          <p>
            我们可能不定期更新本隐私声明，
            更新后将在应用内进行公告。
          </p>
        </section>

        <section>
          <h2>11. 联系我们</h2>

          <p>公司名称：陕西点三信息技术有限公司</p>
          <p>地址：陕西省西安市高新区锦业一路中投国际A座1001室</p>
          <p>联系电话：17392283134</p>
          <p>邮箱：chinarenzhujian@163.com</p>
        </section>

        <section>
          <h2>12. 权限申请说明</h2>

          <p>
            为保障应用正常运行，APP 可能会申请以下权限：
          </p>

          <ul>
            <li>相机权限：扫码配置服务器地址</li>
            <li>存储权限：读取二维码、缓存日志与资源</li>
            <li>网络权限：连接企业服务器与同步数据</li>
            <li>通知权限：展示更新与系统通知</li>
          </ul>
        </section>

        <!-- <p>最近更新时间：2026年05月</p> -->
      </div>
    </div>
  </div>
</template>

<script setup>
// 隐私政策页面
</script>

<style scoped>
.privacy-page {
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f6fa;
  box-sizing: border-box;
}

.container {
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.title {
  text-align: center;
  font-size: 34px;
  font-weight: bold;
  color: #222;
  margin-bottom: 30px;
  box-sizing: border-box;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
}

.content {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.9;
  color: #555;
}

section {
  margin-bottom: 30px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

h2 {
  font-size: 24px;
  color: #222;
  margin-bottom: 15px;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
}

h3 {
  font-size: 18px;
  color: #333;
  margin-top: 16px;
  margin-bottom: 10px;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
}

/* 所有段落强制在容器宽度内自动换行 */
.content p,
p {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0 0 12px;
  box-sizing: border-box;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  word-break: break-all;
  text-align: left;
}

ul {
  width: 100%;
  max-width: 100%;
  padding-left: 22px;
  box-sizing: border-box;
}

li {
  margin-bottom: 8px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
}

@media (max-width: 768px) {
  .container {
    padding: 16px;
    border-radius: 0;
  }

  .title {
    font-size: 32px;
  }

  h2 {
    font-size: 28px;
  }

  .content {
    font-size: 24px;
  }
}

@media (min-width: 769px) {
  .container {
    max-width: 960px;
  }
}
</style>